import { render, staticRenderFns } from "./XaxisChart.vue?vue&type=template&id=23c4d269&scoped=true"
import script from "./XaxisChart.vue?vue&type=script&lang=js"
export * from "./XaxisChart.vue?vue&type=script&lang=js"
import style0 from "./XaxisChart.vue?vue&type=style&index=0&id=23c4d269&prod&lang=scss&scoped=true"
import style1 from "./XaxisChart.vue?vue&type=style&index=1&id=23c4d269&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23c4d269",
  null
  
)

export default component.exports